/**
 * TODO будет перенесено в утилиты и покрыто тестами в https://cianru.atlassian.net/browse/CD-38432
 */
import once from 'lodash/once';

export const initYoutubeIFrame = (): Promise<void> => {
  const tag = document.createElement('script');
  const ytApiSrc = 'https://www.youtube.com/iframe_api';

  tag.src = ytApiSrc;

  const scripts = document.getElementsByTagName('script');
  const firstScriptTag = scripts[0];
  const isYTApiOnPage = Array.from(scripts)
    .map(script => script.src)
    .includes(ytApiSrc);

  if (!isYTApiOnPage && firstScriptTag && firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  return new Promise<void>(resolve => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).onYouTubeIframeAPIReady = resolve;
  });
};

export const createYoutubePlayer = once(initYoutubeIFrame);

export function isYouTube(src: string | undefined): boolean {
  return !!src && /youtu.?be/.test(src);
}

export function getYoutubeID(src: string): string | null {
  // eslint-disable-next-line no-useless-escape
  const ID_REGEXP = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
  const urlSplitted = src.match(ID_REGEXP) || [];

  return urlSplitted.length > 0 ? urlSplitted[1] : '';
}

export function getYoutubeVideoPreviewUrl(src: string): string {
  return `https://img.youtube.com/vi/${getYoutubeID(src)}/hqdefault.jpg`;
}

export function getYoutubeEmbedUrl(src: string): string {
  const id = getYoutubeID(src);

  return `https://www.youtube.com/embed/${id}`;
}

export interface IYouTubeEvent extends Event {
  target: IYouTubeEventTarget;
  data: PlayerState;
}

interface IYouTubeEventTarget extends EventTarget {
  playVideo(): void;
}

export enum PlayerState {
  NOT_PLAYED = -1,
  ENDED = 0,
  PLAYING = 1,
  PAUSED = 2,
  BUFFERING = 3,
  CUED = 5,
}

export const VIDEO_NOT_AVAILABLE_COMBINATION = [PlayerState.NOT_PLAYED, PlayerState.BUFFERING, PlayerState.NOT_PLAYED];

export const VIDEO_IS_PLAYING_STATES = [PlayerState.PLAYING, PlayerState.PAUSED, PlayerState.BUFFERING];
